import { apiService } from './api'

export interface CategoryStats {
  category: string
  rulesCount: number
  testsCount: number
  lastUpdated: string
}

export interface CategoryManageResponse {
  categories: CategoryStats[]
}

export interface UpdateCategoryRequest {
  oldCategory: string
  newCategory: string
}

export interface UpdateCategoryResponse {
  message: string
  updatedCount: number
}

export interface DeleteCategoryResponse {
  message: string
  deactivatedRulesCount: number
}

export interface CreateCategoryRequest {
  category: string
  description?: string
}

export interface CreateCategoryResponse {
  message: string
  category: string
}

export const categoryService = {
  /**
   * カテゴリ統計情報取得（管理用）
   */
  async getCategoriesWithStats(): Promise<CategoryManageResponse> {
    return await apiService.get<CategoryManageResponse>('/compliance/categories/manage')
  },

  /**
   * カテゴリ新規作成
   */
  async createCategory(data: CreateCategoryRequest): Promise<CreateCategoryResponse> {
    return await apiService.post<CreateCategoryResponse>('/compliance/categories/create', data)
  },

  /**
   * カテゴリ名変更
   */
  async updateCategory(data: UpdateCategoryRequest): Promise<UpdateCategoryResponse> {
    return await apiService.put<UpdateCategoryResponse>('/compliance/categories/update', data)
  },

  /**
   * カテゴリ削除
   */
  async deleteCategory(category: string): Promise<DeleteCategoryResponse> {
    return await apiService.delete<DeleteCategoryResponse>(
      `/compliance/categories/${encodeURIComponent(category)}`
    )
  },
}
